module.exports = __webpack_public_path__ + "static/media/package.869dbf6c.png";